module.exports = __webpack_public_path__ + "static/media/34.bace5309.mp3";